// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__t0wru","description":"MealItem_description__F25AA","price":"MealItem_price__GhuUL"};